import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'sap-app',
    loadComponent: () => import('./pages/sa0010/sa0010.component').then((m) => m.Sa0010Component),
    title: '特別勘定ポータル｜第一生命保険株式会社',
  },
  {
    path: 'sap-app/base-info',
    loadComponent: () => import('./pages/sa0011/sa0011.component').then((m) => m.Sa0011Component),
    title: '特別勘定ポータル｜第一生命保険株式会社',
  },
  {
    path: 'sap-app/base-price',
    loadComponent: () => import('./pages/sa0020/sa0020.component').then((m) => m.Sa0020Component),
    title: '基準価額の現況｜特別勘定ポータル｜第一生命保険株式会社',
  },
  {
    path: 'sap-app/base-price/transition',
    loadComponent: () => import('./pages/sa0021/sa0021.component').then((m) => m.Sa0021Component),
    title: '基準価額の推移｜特別勘定ポータル｜第一生命保険株式会社',
  },
  {
    path: 'sap-app/base-price/percent-change',
    loadComponent: () => import('./pages/sa0022/sa0022.component').then((m) => m.Sa0022Component),
    title: '基準価額の騰落率｜特別勘定ポータル｜第一生命保険株式会社',
  },
  {
    path: 'sap-app/base-price/operation-report',
    loadComponent: () => import('./pages/sa0023/sa0023.component').then((m) => m.Sa0023Component),
    title: '運用レポート｜特別勘定ポータル｜第一生命保険株式会社',
  },
  {
    path: 'sap-app/error',
    loadComponent: () => import('./pages/sa9010/sa9010.component').then((m) => m.Sa9010Component),
    title: 'エラー｜特別勘定ポータル｜第一生命保険株式会社',
  },
];
